const theme = {
  colors: {
    // BLACK & WHITE & TRANSPARENT
    black: '#000000',
    white: '#FFFFFF',
    grey: '#C2C2C2',
    mediumGrey: '#a0a0a0',
    transparent: 'transparent',
    none: 'none',
    // NEUTRAL
    neutralColor900: '#2D353E',
    neutralColor700: '#36404B',
    neutralColor500: '#3B444F',
    neutralColor300: '#4B5766',
    neutralColor100: '#8595a5',
    // PRIMARY
    primaryColor900: '#0f302f',
    primaryColor700: '#217572',
    primaryColor500: '#47FFF9',
    primaryColor300: '#85f6f4',
    primaryColor100: '#c0faf9',
    // SECONDARY
    secondaryColor900: '#2d353e',
    secondaryColor700: '#4e6783',
    secondaryColor500: '#89befa',
    secondaryColor300: '#aacbf8',
    secondaryColor100: '#cbe0fc',
    // WHITE ALPHAS
    whiteAlpha90: 'rgba(255, 255, 255, 0.9)',
    whiteAlpha80: 'rgba(255, 255, 255, 0.8)',
    whiteAlpha70: 'rgba(255, 255, 255, 0.7)',
    whiteAlpha60: 'rgba(255, 255, 255, 0.6)',
    whiteAlpha50: 'rgba(255, 255, 255, 0.5)',
    whiteAlpha40: 'rgba(255, 255, 255, 0.4)',
    whiteAlpha30: 'rgba(255, 255, 255, 0.3)',
    whiteAlpha20: 'rgba(255, 255, 255, 0.2)',
    whiteAlpha10: 'rgba(255, 255, 255, 0.1)',
    // BLACK ALPHAS
    blackAlpha90: 'rgba(0, 0, 0, 0.9)',
    blackAlpha80: 'rgba(0, 0, 0, 0.8)',
    blackAlpha70: 'rgba(0, 0, 0, 0.7)',
    blackAlpha60: 'rgba(0, 0, 0, 0.6)',
    blackAlpha50: 'rgba(0, 0, 0, 0.5)',
    blackAlpha40: 'rgba(0, 0, 0, 0.4)',
    blackAlpha30: 'rgba(0, 0, 0, 0.3)',
    blackAlpha20: 'rgba(0, 0, 0, 0.2)',
    blackAlpha10: 'rgba(0, 0, 0, 0.1)',
    //MAIN BLUE
    mainBlue1000: 'rgba(63, 154, 247,1)',
    mainBlue800: 'rgba(63, 154, 247,0.8)',
    mainBlue500: 'rgba(71, 182, 255, 1)',
    mainBlue200: 'rgba(63, 154, 247,0.2)',

    // ACCENTS
    // -- ERROR
    errorColor900: '#4f1b16',
    errorColor700: '#a23527',
    errorColor500: '#ff543d',
    errorColor300: '#fa8c7e',
    errorColor100: '#fdafa2',
    // -- WARNING
    warningColor900: '#3c280f',
    warningColor700: '#b37237',
    warningColor500: '#FF9955',
    warningColor300: '#ffc373',
    warningColor100: '#ffefe7',
    // -- CAREFUL
    carefulColor900: '#291f08',
    carefulColor700: '#51470a',
    carefulColor500: '#FFDC1E',
    carefulColor300: '#fff663',
    carefulColor100: '#fff3aa',
    // -- SUCCESS
    successColor900: '#00693e',
    successColor700: '#00a966',
    successColor500: '#00FF99',
    successColor300: '#7efcc5',
    successColor100: '#b4ffe6',
  },
  gradient: {
    cardBackground: 'linear-gradient(120deg,#4B5766 0,#3B444F 100%)',
  },
  shadow: {
    main: '4px 4px 15px 0px #293038;',
  },
  sizes: {
    h1: '1.7rem',
    h2: '1.3rem',
    h3: '1.2rem',
    h4: '1rem',
    h5: '0.9rem',
    h6: '0.8rem',
    p: '0.7rem',
    body: '14px',
    span: '1rem',
  },
  fonts: {
    primary: 'Work Sans, sans-serif',
    secondary: 'sans-serif',
  },
}

const defaultTheme = {
  ...theme,
  isMobile: false,
  // ADD specific themes and overrides here
}

export const COLOR_KEYS = Object.keys(theme.colors)
export const GRADIENT_KEYS = Object.keys(theme.gradient)
export const SIZE_KEYS = Object.keys(theme.sizes)
export const FONT_KEYS = Object.keys(theme.fonts)

export default defaultTheme
